<script setup lang="ts">
import type { RouteLocationRaw } from 'vue-router'
import { scrollToTop } from '@/utils/util'
import type { ThemeColors } from '@/composables/memorize/memorize'
import { computed } from 'vue'

export interface CommonRouteTabOption {
  to: RouteLocationRaw
  display: string
  disabled?: boolean
  name?: string
  icon?: string
  hide?: boolean
  match?: boolean
  params?: Record<string, string>
}

const {
  options,
  themeColors,
  theme,
  replace,
  preventScrollTop = false
} = defineProps<{
  options: CommonRouteTabOption[]
  themeColors?: ThemeColors
  theme?: Boolean
  // command?: boolean    // 快捷键系统 - 暂不实现
  replace?: boolean
  preventScrollTop?: boolean
}>()
</script>

<template>
  <div
    overflow-hidden
    w-full
    min-h-12
    items-center
    of-x-auto
    lg:text-base
    flex="~ row"
    border-b-1
    border-light
    justify-center>
    <div w-full flex="~ row" items-center justify-center md:max-w-3xl lg:max-w-4xl text-base>
      <template v-for="(option, index) in options.filter((item) => !item.hide)" :key="option?.name || index">
        <router-link
          v-if="!option.disabled"
          :to="{ path: option.to as string, query: option.params }"
          :replace="replace"
          tabindex="1"
          relative
          flex
          flex-auto
          cursor-pointer
          transition-100
          transition-all
          text-center
          :exact-active-class="
            theme
              ? `!children:w-full !children:md:w-auto !children:border-theme-main !children:font-bold !children:text-theme-main !children:op100`
              : `!children:w-full !children:md:w-auto !children:border-primary-active !children:text-primary-active !children:op100`
          "
          @click="!preventScrollTop && scrollToTop()">
          <span
            mxa
            ws-nowrap
            border-b-1.5
            border-transparent
            flex="~ row"
            items-center
            :class="theme ? 'text-theme-gray' : 'text-second'"
            justify-center
            min-h-12
            >{{ option.display || '&nbsp;' }}</span
          >
        </router-link>
        <div v-else flex flex-auto px2 sm:px5 xl:pb3 xl:pt4>
          <span mxa ws-nowrap py2 text-center text-theme-gray op50 sm:py>{{ option.display }}</span>
        </div>
      </template>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.custom-bg {
  background-color: var(--bg-color);
}
.custom-hover:hover {
  background-color: var(--hover-color);
}
</style>
